import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        save: false,
        error: false,
        contacts: [],
        contactsLoading: false,
        groups: [],
		groupsLoading: false,
		group: null,
		room: null,
        csvUsers: false,
        csvFiles: false
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FTV_CONTACT_CREATE_START:
            return updateObject(state, { save: true });
        case actionTypes.FTV_CONTACT_EDIT_START:
            return updateObject(state, { save: true });
        case actionTypes.FTV_CONTACTS_SEARCH_START:
            return updateObject(state, { contactsLoading: true });
        case actionTypes.FTV_CONTACTS_SEARCH_FAIL:
            return updateObject(state, { contactsLoading: false });
        case actionTypes.FTV_CONTACTS_SEARCH_SUCCESS:
			return updateObject(state, { contactsLoading: false, contacts: action.contacts.msg.data });
		case actionTypes.FTV_GROUPS_SEARCH_START:
            return updateObject(state, { groupsLoading: true });
        case actionTypes.FTV_GROUPS_SEARCH_FAIL:
            return updateObject(state, { groupsLoading: false });
        case actionTypes.FTV_GROUPS_SEARCH_SUCCESS:
			return updateObject(state, { groupsLoading: false, groups: action.groups.msg.data });
		case actionTypes.FTV_GROUP_GET_SUCCESS:
			return updateObject(state, { groupsLoading: false, group: action.group.msg.data });
		case actionTypes.FTV_CONTACT_CREATE_FAIL:
            return updateObject(state, { error: action.error, save: action.save });
        case actionTypes.FTV_CONTACT_CREATE_SUCCESS:
            return updateObject(state, { error: false, save: false });
        case actionTypes.FTV_CONTACT_EDIT_FAIL:
            return updateObject(state, { error: action.error, save: action.save });
        case actionTypes.FTV_CONTACT_EDIT_SUCCESS:
            return updateObject(state, { error: false, save: false });
        case actionTypes.FTV_CLEAR_ERROR:
            return updateObject(state, { error: false, save: false });
        case actionTypes.FTV_GROUP_SAVE_SUCCESS:
            return updateObject(state, { group: action.group });
		case actionTypes.FTV_CONTACTS_SET_ROOM:
            return updateObject(state, { room: action.room });
        case actionTypes.FTV_LOAD_CSV_USERS_SUCCESS:
            return updateObject(state, { csvUsers: action.users });
        case actionTypes.FTV_LOAD_CSV_FILES_SUCCESS:
            return updateObject(state, { csvFiles: action.files });
        default: 
            return state;
    }
}

export default reducer;
